/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/forbid-prop-types */

import React, {
  useEffect,
  useMemo,
  useState,
  useRef,
  useCallback,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { CircularProgress } from '@material-ui/core';
import { Check } from '@material-ui/icons';
import { parseISO, format, subDays } from 'date-fns';
import { isUndefined } from 'lodash';
import PropTypes from 'prop-types';

import { Modal } from '~/components';
import { Checkbox, Input } from '~/components/Form';
import { t, number } from '~/helpers';
import api from '~/services/api';
import { recordFiltering as recordFilteringLogs } from '~/store/modules/LogsDescarregamentos/actions';
import {
  recordFiltering,
  setPresetAndProduto,
} from '~/store/modules/LogsDescarregamentosItem/actions';

import UnidataTable from './components/UnidataTable';
import * as S from './styles';

export function AssociarModal({ loadingSending }) {
  return (
    <>
      {' '}
      {loadingSending ? (
        <div>
          <CircularProgress
            size={20}
            color="primary"
            style={{ marginRight: '1.5rem' }}
          />
        </div>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <p>Deseja associar o log a essa programação ?</p>
          <p style={{ color: '#f50057' }}>
            {t('s.geral.acaonaopoderaserdesfeita')}
          </p>
        </div>
      )}
    </>
  );
}

export default function AssociarComponente(props) {
  const dispatch = useDispatch();

  const dataLog = props.data;

  const totalVolume = props.visible
    ? number(dataLog.volumelogdescarga + 0, 1)
    : 0;

  const dataParamsLogs = useSelector((state) => state.logsdescarregamentos);

  const data = useSelector((state) => state.logsdescarregamentositem);

  const [selectedRow, setSelectedRow] = useState({});

  const modalRefAss = useRef(null);

  const [showAllDates, setShowAllDates] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [loadAss, setLoadAss] = useState(false);

  useEffect(() => {
    async function handleSetPresetAndProduto() {
      await dispatch(
        setPresetAndProduto(props.data.idpreset, props.data.idproduto)
      );
      setShowTable(true);
    }

    if (!isUndefined(props.data)) handleSetPresetAndProduto();
  }, [props]);

  const header = useMemo(() => {
    const dateArrayHeader = showAllDates
      ? [
          {
            id: 'datahorainiciodescarganf',
            label: t('s.operacao.recebimento.datahorainiciodescarga'), // 'Data Programação',
            formatted: (value) =>
              value ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : value,
          },

          {
            id: 'datahorafimdescarganf',
            label: t('s.operacao.recebimento.datahorafimdescarga'), // 'Data Programação',
            formatted: (value) =>
              value ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : value,
          },
        ]
      : [
          {
            id: 'datahorainiciodescarganf',
            label: t('s.operacao.recebimento.datahorainiciodescarga'), // 'Data Programação',
            formatted: (value) =>
              value ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : value,
            filter: {
              type: 'initialdatetime',
              defaultValue: format(
                subDays(new Date(), 7),
                'dd/MM/yyyy 00:00:00'
              ),
            },
          },

          {
            id: 'datahorafimdescarganf',
            label: t('s.operacao.recebimento.datahorafimdescarga'), // 'Data Programação',
            formatted: (value) =>
              value ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : value,
            filter: {
              type: 'finaldatetime',
              defaultValue: format(new Date(), 'dd/MM/yyyy 23:59:59'),
            },
          },
        ];

    return [
      ...dateArrayHeader,

      {
        id: 'datahoradescarganf',
        label: t('s.operacao.recebimento.datahoradescarganf'), // 'Data Criação',
        formatted: (value) =>
          value ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : value,
      },
      {
        id: 'idposto',
        label: t('s.menu.configuracao.posto'), // 'Posto',
        filter: { type: 'text' },
      },
      {
        id: 'idpreset',
        label: t('s.cadastro.preset.idpreset'), // 'Preset',
        filter: { type: 'text' },
      },
      {
        id: 'nfdescarganf',
        label: t('s.relatorio.descarga.notafiscal'), // 'Nota Fiscal',
        filter: { type: 'text' },
      },
      {
        id: 'nomeproduto',
        label: t('s.operacao.recebimento.nomeproduto'), // 'Produto',
        filter: { type: 'text' },
      },
      {
        id: 'placactdescarganf',
        label: t('s.operacao.recebimentonf.placactdescarganf'), // 'Placa Veículo',
        filter: { type: 'text' },
      },

      {
        id: 'volumenfdescarganf',
        label: t('s.operacao.recebimento.compartimentos.volumedeclarado'), // 'Volume Programado',
        filter: { type: 'number' },
        formatted: (value) => number(value, 1),
      },
      {
        id: 'volumeambientedescarganfrealizado',
        label: t('s.operacao.logdescarga.volumedescarregado'), // 'Volume Realizado',
        filter: { type: 'number' },
        formatted: (value) => number(value, 1),
      },
      {
        id: 'situacaodescargastr',
        label: t('s.operacao.recebimentonf.skid.situacao'), // 'Situação',
      },
    ];
  }, [showAllDates]);

  const handleAssociarLog = useCallback(
    async (values) => {
      try {
        setLoadAss(true);
        await api.get(
          `descargasnfs/${dataLog.idlogdescarga}/${values.iddescarganf}/${values.idposto}/`
        );
        toast.success(
          t('s.operacao.logdescarregamentonaoprocessado.logassociadocomsucesso')
        ); // 'Log associado com sucesso !!');
        // await dispatch(recordFiltering(values.params));
        props.close();
        await dispatch(recordFilteringLogs(dataParamsLogs.params));
      } catch (err) {
        err.map((error) => toast.error(error));
      } finally {
        modalRefAss.current.handleCloseModal();
        setLoadAss(false);
      }
    },
    [modalRefAss, dataLog, props, dataParamsLogs]
  );

  const buttons = useMemo(
    () => [
      {
        label: t('s.geral.botaoconfirmar'),
        callback: () => handleAssociarLog(selectedRow),
        color: 'primary',
        autoFocus: true,
      },
      {
        label: t('s.geral.botaofechar'),
        callback: () => modalRefAss.current.handleCloseModal(),
        color: 'secondary',
      },
    ],
    [modalRefAss, selectedRow]
  );

  const actionsButtons = useMemo(
    () => [
      {
        title: t('s.operacao.logdescarregamentonaoprocessado.associar'), // 'Associar',
        action: () =>
          modalRefAss.current.handleOpenModal({ loadingSending: loadAss }),
        icon: <Check />,
      },
    ],
    [modalRefAss, loadAss]
  );

  // const handleShowFinalizedDates = useCallback((value) => {
  //   if (showAllDates) {
  //     dispatch(recordFiltering({
  //       page: data.page,
  //       pagesize: data.pagesize,
  //       nomepresetreceita: data.nomepresetreceita,
  //       item_finalizado: value
  //     }))
  //   } else {
  //     dispatch(recordFiltering({ ...data.params, item_finalizado: value }))
  //   }

  // }, [data.params, showAllDates])

  return (
    <>
      <S.HeaederForm initialData={{ ...dataLog }}>
        <Input name="idlogdescarga" label="Código Log" disabled />
        <Input
          name="idpreset"
          label={t('s.cadastro.preset.idpreset')}
          disabled
        />
        <Input
          // name="idproduto"
          // label={t('s.cadastro.presetreceita.nomepresetreceita')}
          name="nomeabreviadoproduto"
          label={t('s.operacao.recebimento.nomeproduto')}
          disabled
        />
        <Input
          name="veiculologdescarga"
          label={t('s.menu.cadastro.veiculo')}
          disabled
        />
        <Input
          name="_"
          label={t('s.relatorio.descarganf.volumerecebido')} // "Vol. Descarregado"
          value={totalVolume}
          disabled
        />
      </S.HeaederForm>
      <S.HeaederForm>
        <Checkbox
          name="filterData"
          label={t(
            's.operacao.logdescarregamentonaoprocessado.exibirtodasasdatas'
          )} // "Exibir todas as datas"
          getValue={(value) => setShowAllDates(value)}
        />

        {/* <Checkbox
          name="showFinalizedDates"
          label="Exibir programações finalizadas"
          getValue={(value) => handleShowFinalizedDates(value)}
        /> */}
      </S.HeaederForm>
      {showTable && (
        <UnidataTable
          fixed
          dense
          maxHeight="300px"
          read={recordFiltering}
          redux={data}
          header={header}
          create={false}
          delete={false}
          update={false}
          detach="idpreset"
          keys={['idpreset']}
          actions={actionsButtons}
          onRow={(value) => setSelectedRow(value)}
        />
      )}

      <Modal
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalRefAss}
        maxWidth="xs"
        title={t(
          's.operacao.logdescarregamentonaoprocessado.associarloganotafiscal'
        )} // "Associar Log a programação"
        component={AssociarModal}
        actions={buttons}
      />
    </>
  );
}

AssociarComponente.propTypes = {
  data: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
};

AssociarComponente.defaultProps = {};

AssociarModal.propTypes = {
  loadingSending: PropTypes.bool.isRequired,
};

AssociarModal.defaultProps = {};
